import SchedulerWidgetImage from '@/assets/plan-selection/scheduler/widget.png';
import SchedulerNotificationImage from '@/assets/plan-selection/scheduler/notification.png';
import SchedulerTeamsImage from '@/assets/plan-selection/scheduler/teams.png';
import SchedulerOneToManyImage from '@/assets/plan-selection/scheduler/one-to-many.png';
import SchedulerManagedSchedulesImage from '@/assets/plan-selection/scheduler/managed-schedules.png';
import SchedulerIntegrationsImage from '@/assets/plan-selection/scheduler/integrations.png';
import SchedulerCheckConflictImage from '@/assets/plan-selection/scheduler/check-conflict.png';
import SchedulerGroupsImage from '@/assets/plan-selection/scheduler/groups.png';
import SchedulerRemoveBrandingImage from '@/assets/plan-selection/scheduler/remove-branding.png';
import SchedulerAddLogoToEmailImage from '@/assets/plan-selection/scheduler/add-logo-to-email.png';
import SchedulerCustomEmailStyleImage from '@/assets/plan-selection/scheduler/custom-email-style.png';

import ClipsWidgetImage from '@/assets/plan-selection/clips/widget.png';

export const PLAN_SELECTION_IMAGE_MAP = {
  SCHEDULER_WIDGET: SchedulerWidgetImage,
  SCHEDULER_NOTIFICATION: SchedulerNotificationImage,
  SCHEDULER_CREATE_TEAMS: SchedulerTeamsImage,
  SCHEDULER_BOOK_GROUPS: SchedulerOneToManyImage,
  SCHEDULER_ACROSS_TEAMS: SchedulerTeamsImage,
  SCHEDULER_TEMPLATES: SchedulerManagedSchedulesImage,
  SCHEDULER_PREMIUM: SchedulerIntegrationsImage,
  SCHEDULER_CALENDARS: SchedulerCheckConflictImage,
  SCHEDULER_CREATE_GROUPS: SchedulerGroupsImage,
  SCHEDULER_REMOVE_BRANDING: SchedulerRemoveBrandingImage,
  SCHEDULER_ADD_LOGO: SchedulerAddLogoToEmailImage,
  SCHEDULER_CUSTOM_EMAIL_STYLE: SchedulerCustomEmailStyleImage,

  CLIPS_WIDGET: ClipsWidgetImage,
}
